import React from 'react';
import {ButtonG, TextArea, TokenInput} from '../Common';
import * as msgpub from "msgpub";
import { TextInput, Box } from 'grommet';
import { MainStyleForGrommet } from '../../constant/Styles';
import { DisabelesAdminContext, SetDisablesAdminContext, connectingForAdmin, disconnectingForAdmin, onClickForAdmin, beforeConnectingForAdmin } from '../../constant/AdminMqtt';
import { removeNonNumericChar, blurActiveElement, USER_OPTION } from '../../common/common';

export default function AdminLoginComponent(props: {admin?: msgpub.Admin, setAdmin: any, setAppForMsg: any, setActiveIndice: any}){
    const {admin, setAdmin, setAppForMsg, setActiveIndice} = props;
    const [timeout, setTimeout] = React.useState("");
    const [log, setLog] = React.useState("");
    const [appName, setAppName] = React.useState("");
    const [seckey, setSeckey] = React.useState("");
    const disables = React.useContext(DisabelesAdminContext);
    const setDisables = React.useContext(SetDisablesAdminContext);
    const [isClicked, setIsClicked] = React.useState(false); // 接続ボタンが押されたかどうか

    React.useEffect(() => {
        if (admin !== undefined && appName !== "" && seckey !== "" && isClicked) {
            admin.setConnectCallback(() => {
                setLog((prevLog: string) => (prevLog + "connected.\n"));
                setDisables(connectingForAdmin);
                setAppForMsg("app: " + appName);
                setActiveIndice([1, 2, 3]);
            });
            admin.setErrorCallback((e: Error) => {
                setLog((prevLog: string) => (prevLog + e.message + '\n'));
                setDisables(beforeConnectingForAdmin);
                setIsClicked(false);
            });
            admin.setCloseCallback(() => {
                setLog((prevLog: string) => (prevLog + 'closed.\n'));
                setDisables(beforeConnectingForAdmin);
                setIsClicked(false);
            });
            admin.connect();
            setDisables(onClickForAdmin);
            blurActiveElement();
        }
    }, [admin, appName, seckey, setLog, setDisables, isClicked, setIsClicked, setAppForMsg, setActiveIndice]);

    const onChangeForApp = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAppName(event.target.value);
    }

    const onChangeForSeckey = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSeckey(event.target.value);
    }

    const onChangeForTimeout = (event: React.ChangeEvent<HTMLInputElement>) => {
        removeNonNumericChar(event.target.value, setTimeout);
    }

    const connect = () => {
        if (appName !== "" && seckey !== "") {
            const option = USER_OPTION;
            let options = {
                ...option,
                app: appName,
                secKey: seckey,
                timeout: timeout === "" ? 30 : Number(timeout)
            };
            setAdmin(new msgpub.Admin(options));
            setIsClicked(true);
            setAppForMsg();
            setActiveIndice([0]);
        }
    };

    const reload = () => {
        window.location.reload();
    };

    const disconnect = () => {
        if (admin !== undefined){
            admin.setCloseCallback(() => {
                setLog((prevLog: string) => (prevLog + "disconnected.\n"));
                setDisables(disconnectingForAdmin);
                setIsClicked(false);
            });

            if (disables !== onClickForAdmin) {
                admin.close();
            } else {
                admin.forceClose();
            }

            blurActiveElement();
        }
    };

    return (
        <div>
            <Box {...MainStyleForGrommet}>
                <form>
                    <TextInput placeholder="app" value={appName} onChange={onChangeForApp} disabled={disables.app}/>
                    <TokenInput placeholder="seckey" value={seckey} onChange={onChangeForSeckey} disabled={disables.seckey}/>
                    <TextInput placeholder="timeout:(default 30s)" value={timeout} onChange={onChangeForTimeout} disabled={disables.timeout}/>
                    <ButtonG name="connect" callback={connect} disabled={disables.connect}/>
                    <ButtonG name="disconnect" callback={disconnect} disabled={disables.disconnect}/>
                    <ButtonG name="switch admin" callback={reload} disabled={disables.switch}/>
                </form>
            </Box>
            <Box>
                <TextArea texts={log} name={"log"} disabled={disables.loginlog} id={"admin-login-log"} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {setLog(e.target.value)}}/>
            </Box>
        </div>
    );
}
